export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Hand_Normal.23f97062.tga";